import PropTypes from 'prop-types';

import { BaseBlockType, ComponentConfigurationBlockType } from './common.types';

export const VideoBlockPropType = PropTypes.shape({
  ...BaseBlockType,
  ...ComponentConfigurationBlockType,
  videoId: PropTypes.string,
  url: PropTypes.string,
  source: PropTypes.oneOf(['youtube', 'vimeo', 'other']),
  placeholder: PropTypes.string,
});
